import Dashboard from "../Pages/Dashboard.jsx";
import InternalFormPage from "../Pages/InternalFormPage.jsx";
import CustomerProcessPage from "../Pages/CustomerProcessPage.jsx";
import RejectApplicationPage from "../Pages/RejectApplicationPage.jsx";
import CopyCustomerPage from "../Pages/CopyCustomerPage.jsx";
import LoginForm from "./LoginForm.jsx";
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import companyLogo from "../assets/2.png";
import "./AuthenticatedApp.css"; // 👈 import stylesheet

const allowedUsers = process.env.REACT_APP_ALLOWED_COPY_USERS.split(",").map(user => user.trim());

const AuthenticatedApp = ({ onLogout, onLogin, user}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isInvite = pathname.startsWith('/invite');
  const domainBlocked = !!user && !user.username.endsWith("@sidneylee.com");

  useEffect(() => {
    if (!domainBlocked) return;
    const timer = setTimeout(() => onLogout(), 2000);
    return () => clearTimeout(timer);
  }, [domainBlocked, onLogout]);

  if (!user) {
    return <LoginForm onLogin={onLogin} />;
  }
  if (domainBlocked) {
    return <p>Sign-in restricted to @sidneylee.com accounts only.</p>;
  }

  console.log(JSON.stringify(user.name, null, 2));

  const isAllowed = allowedUsers.includes(user?.username?.toLowerCase());

  const RestrictedRoute = ({ children }) =>
    isAllowed ? (
      children
    ) : (
      <div className="access-denied">
        <h1>🚫 Access Denied</h1>
        <p>You do not have permission to view this page.</p>
        <button
          className="back-button"
          onClick={() => navigate("/")}
        >
          ⬅ Back to Dashboard
        </button>
      </div>
    );

  return (
    <div className="app-container">
      {!isInvite && (
        <nav className="app-nav">
          <img src={companyLogo} alt="Company Logo" className="company-logo" />

          <div className="logged-in">
            Logged In As:{" "}
            <span className="logged-in-name">{user.name || user.username}</span>
          </div>

          <button
            onClick={onLogout}
            className="logout-button"
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#b30000")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#d40000")
            }
          >
            LOGOUT
          </button>
        </nav>
      )}

      <Routes>
        <Route index element={<Dashboard isAllowed={isAllowed} />} />
        <Route path="internal" element={<InternalFormPage />} />
        <Route
          path="process"
          element={
            <RestrictedRoute>
              <CustomerProcessPage />
            </RestrictedRoute>
          }
        />
        <Route
          path="reject"
          element={
            <RestrictedRoute>
              <RejectApplicationPage />
            </RestrictedRoute>
          }
        />
        <Route
          path="copy"
          element={
            <RestrictedRoute>
              <CopyCustomerPage />
            </RestrictedRoute>
          }
        />
      </Routes>
    </div>
  );
};

export default AuthenticatedApp;
